<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >

  <v-layout row justify-center>
    <v-dialog v-model="historidetail" persistent max-width="700px">
      <!-- <template v-slot:activator="{on}">
      </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Histori Aktivasi Serial</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-data-table>
                
              </v-data-table>

            </v-layout>
          </v-container>
          <small>*harus diisi</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="historidetail = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>

    
  <v-layout row justify-center>
    <v-dialog v-model="editserial" persistent max-width="600px">
      <!-- <template v-slot:activator="{on}">
      </template> -->
      <v-form @submit.prevent="resetaktivasi">

      <v-card>
        <v-card-title>
          <span class="headline">Reset Aktivasi</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm12 md12>
                <v-text-field v-show="false" v-model="idserial" label="Serial number*" required></v-text-field>
                <v-text-field  :disabled="true" v-model="sn" label="Serial number*" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field :disabled="true" v-model="program" label="Last Aktivasi" hint="example of helper text only on focus"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="alasan"
                  :rules="alasanRules"
                  label="Alasan reset aktivasi*"
                  hint="isikan alasan lengkap kenapa aktivasi anda reset"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
              
              
              <!-- <v-flex xs12 sm6>
                <v-autocomplete
                  :items="['Skiing', 'Ice hockey', 'Soccer', 'Basketball', 'Hockey', 'Reading', 'Writing', 'Coding', 'Basejump']"
                  label="Interests"
                  multiple
                ></v-autocomplete>
              </v-flex> -->
            </v-layout>
          </v-container>
          <small>*harus diisi</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1"   @click="editserial = false">Close</v-btn>
          <v-btn color="blue darken-1" type="submit" >Reset</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
  </v-layout>

    <!-- <base-v-component
      heading="Serial Number"
      link="components/simple-tables"
    /> -->

    
    
    <base-material-card
      icon="mdi-clipboard-text"
      title="Data Serial Number"
      class="px-7 py-3"
    >
      <v-container fluid >
        <v-row>
        
          <v-text-field
            :label="$t('search')"
            color="secondary"
            hide-details
            style="max-width: 165px;"
            v-model="cari"

          >
            <template
              v-if="$vuetify.breakpoint.mdAndUp"
              v-slot:append-outer
            >
              <v-btn
                @click="filterdata()"
                class="mt-n2"
                elevation="1"
                fab
                small
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-row>
    </v-container>
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">
              Action
            </th>
            <th class="primary--text">
              Serial
            </th>
            <th class="primary--text">
              Program
            </th>
            <th class="primary--text">
              Group
            </th>
            <th class="text-right primary--text">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d,i) in dataSerial" :key="i">
            <td>
              <v-btn  @click="infodetail(d.SN)" color="primary" fab x-small darkk>
                <v-icon>mdi-information-outline</v-icon>
              </v-btn> 
              
              <v-btn v-show="d.aktif=='0'" @click="detail(d.Nomor,d.SN,d.keterangan)" color="primary" fab x-small darkk>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>{{d.SN}}</td>
            <td>{{d.keterangan}}</td>
            <td>{{d.group}}</td>
            <td class="text-right">
              <v-btn depressed small color="primary"  v-if="d.aktif=='1'">Aktif</v-btn>
              <v-btn depressed small color="error" v-else>Tidak Aktif</v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </base-material-card>
    <div class="py-3" />
  </v-container>
</template>

<script>

import { mapActions, mapState } from 'vuex';
export default {
  name: 'Serial',
  data(){
    return {
       
      cari:'',
      serialnomor:'',
      historidetail:false,
      editserial: false,
      idserial:'',
      sn:'',
      program:'',
      alasan:'',
      alasanRules: [
      v => !!v || 'Alasan is required',
      ],
        
      headers:[
        {text:'Action',align :'start',value:'action'    }, 
        {text:'Serial',
          value:'serial',
        },
        {text:'Program',
          value:'program',
        },
        {text:'Group',
          value:'kdgroup',
        },
        {
          text:'Status',
          value:'status',
        },

      ]
      


    };
  },

  created(){
    this.loadserial();
  },
  computed : {
    ...mapState(['API_URL']),
    ...mapState('serial',['dataSerial']),

  },
  methods :{
    ...mapActions('serial',['getSerial','resetserialnumber']),
    
    alertNotif(title, type, text) {
      this.$swal({
        heightAuto: false,
        title,
        type,
        text,
      });
    },

    filterdata(){
        // this.alertNotif("data",'success','gel');
        const param = new FormData();
        param.append('filter',this.cari);
        this.getSerial(param).then((res)=>{
          if (res.success){

          }else{

          }

        });
    },

    resetaktivasi(){
       console.log ('df');
      
      if ( (this.sn=='')||(this.alasan=='')) {
        this.editserial=false;
      }else{
        const self = this;
        self.$swal({
          text: 'Anda yakin mereset aktivasi ' + this.sn  + ' ?' ,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Tidak',
          confirmButtonText: 'Ya',
        }).then((result) => {
          if (result) 
          { 
              if (this.editserial) {
                      this.editserial = true;
                      const fd = new FormData();
                      fd.append('idserial', this.idserial);
                      fd.append('sn', this.sn);
                      fd.append('userid', '1');
                      fd.append('ket', this.alasan);
                      console.log ('masuk ke reset', this.alasan);
                      this.resetserialnumber(fd).then((res) => {
                        this.editserial = false;
                        if (res.success) {
                          this.editserial = false;
                          
                          const message = `${'<h3>Forward Berhasil</h3>'}`;
                          this.$swal({
                            html: message,
                            type: 'success',
                            title: 'Berhasil',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Oke',
                            confirmButtonText: 'Tutup',
                          }).then((result) => {
                            if (result) {
                              this.idserial='';
                              this.sn='';
                              this.alasan='';
                              this.loadserial();
                            }
                          });
                        } else {
                          this.alertNotif('Failure', 'warning', res.message);
                        }
                      });
                }
         } 
        });
      }
    },
    detail(nomor,sn,prg){
      this.editserial=true;
      this.idserial=nomor;
      this.sn=sn;
      this.program=prg;

      // this.$swal("Counter was closed!", "Please go to Setting to open counter!");
      //this.alertNotif("Edit Data","Edit","Dilahkan edit data" + nomor);
    },
    infodetail(snku){
      this.historidetail=true;
    },

    loadserial(){
      const param=new FormData();
      param.append('kdgroup','-');
      this.getSerial(param);

    },


  },
}
</script>
